import * as Styled from "./CatalogItemsGrading.styled"

export function CatalogItemsGradingSkeleton(props) {
    return <div {...props}>
        <Styled.Skeleton {...props} />
    </div>
}